module.exports = __webpack_public_path__ + "img/web.bcb50938.webp";